import { AkaGroupLifeProduct } from "Store/interfaces/products/checkout/lifeProducts/AkaGroupLifeProduct";
import { isDefined } from "Utils/functions";
import { ProductDetail } from "../../interface";

export const akaGroupLifeDetailsList = (
  product: AkaGroupLifeProduct,
): ProductDetail[] => {
  return [
    {
      name: "memberDeath",
      value: `${product.memberApplicantInsuranceSpecification?.deathInsuranceCoverageGLevel} G`,
      hidden:
        !isDefined(product.memberApplicantInsuranceSpecification) ||
        product.memberApplicantInsuranceSpecification
          ?.deathInsuranceCoverageGLevel === 0,
    },
    {
      name: "memberIncapacity",
      value: `${product.memberApplicantInsuranceSpecification?.incapacityOfWorkCoverageGLevel} G`,
      hidden:
        !isDefined(product.memberApplicantInsuranceSpecification) ||
        product.memberApplicantInsuranceSpecification
          ?.incapacityOfWorkCoverageGLevel === 0,
    },
    {
      name: "memberTimeLimited",
      value: `${product.memberApplicantInsuranceSpecification?.timeLimitedDisabilityInterestCoverageGLevel} G`,
      hidden:
        !isDefined(product.memberApplicantInsuranceSpecification) ||
        product.memberApplicantInsuranceSpecification
          ?.timeLimitedDisabilityInterestCoverageGLevel === 0,
    },
    {
      name: "coInsuredDeath",
      value: `${product.coInsuredApplicantInsuranceSpecification?.deathInsuranceCoverageGLevel} G`,
      hidden:
        !isDefined(product.coInsuredApplicantInsuranceSpecification) ||
        product.coInsuredApplicantInsuranceSpecification
          ?.deathInsuranceCoverageGLevel === 0,
    },
    {
      name: "coInsuredIncapacity",
      value: `${product.coInsuredApplicantInsuranceSpecification?.incapacityOfWorkCoverageGLevel} G`,
      hidden:
        !isDefined(product.coInsuredApplicantInsuranceSpecification) ||
        product.coInsuredApplicantInsuranceSpecification
          ?.incapacityOfWorkCoverageGLevel === 0,
    },
    {
      name: "coInsuredTimeLimited",
      value: `${product.coInsuredApplicantInsuranceSpecification?.timeLimitedDisabilityInterestCoverageGLevel} G`,
      hidden:
        !isDefined(product.coInsuredApplicantInsuranceSpecification) ||
        product.coInsuredApplicantInsuranceSpecification
          ?.timeLimitedDisabilityInterestCoverageGLevel === 0,
    },
  ];
};
